module.exports = __webpack_public_path__ + "static/img/icon-party-cracker.aa56292.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-party-cracker.png
// module id = /Rl9
// module chunks = 1